import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import { pageModel } from '../../utils/model';
import { ACCOUNT_PATH, getPageAccounts } from '../../api/accountApi';
import { setAccountSearchParamsAction } from '../../redux/feature/accountSlice';

const AccountListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [accountPage, setAccountPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${ACCOUNT_PATH}/page`, false)
    const searchParams = useSelector(state => state.account.searchParams)
    const [searchTimer, setSearchTimer] = useState();

    const loadAccounts = (params) => {
        !pendingApiCall &&
            getPageAccounts(params)
                .then(res => {
                    setAccountPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const onLoadMore = () => {
        if (!accountPage.last) {
            loadAccounts({ ...searchParams, productId: searchParams.product?.id, lastId: accountPage.content[accountPage.content.length - 1]?.id })
        }
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageAccounts(params)
                .then(res => {
                    setAccountPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)

    useEffect(() => {
        loadAccounts({ size: 20, ...searchParams, productId: searchParams.product?.id })
    }, [])

    useEffect(() => {
        !isFirstRender && searching({ ...searchParams })
    }, [searchParams])

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl uppercase'>
                    Hesaplar
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Hesap</label>}
                    variant='green'
                    onClick={() => nav('/account/add')}
                />
            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-3/12'>Hesap Kodu</th>
                        <th className='p-2 w-3/12'>Hesap Adı</th>
                        <th className='p-2 w-4/12'>Açıklama</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                onChange={e => dispatch(setAccountSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                                value={searchParams.id}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="code"
                                placeholder='Hesap kodu...'
                                onChange={e => dispatch(setAccountSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                                value={searchParams.code}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Hesap adı...'
                                onChange={e => dispatch(setAccountSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                                value={searchParams.name}
                            />
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                    </tr>
                    {
                        accountPage.content.map((account, index) => (
                            <tr key={account.id} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {account.id} </td>
                                <td className='p-2'>{account.code} </td>
                                <td className='p-2'>{account.name}</td>
                                <td className='p-2 '>{account.description}</td>
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/account/edit/${account.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(account.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={accountPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
        </div>
    )
}

export default AccountListPage